import { Navigate, useParams } from 'react-router-dom';

// The standalone API-keys page became a tab of the project console (M8);
// this route survives as a redirect so old links keep working.
export const ApiKey = () => {
  const params = useParams();
  return <Navigate to={`/${params.id}/console?tab=api-keys`} replace />;
};
